import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '../../../lib/api-fetcher';

export interface Holiday {
  id: string;
  name: string;
  date: string;
  isRecurring: boolean;
}

export type CreateHolidayInput = Pick<Holiday, 'name' | 'date' | 'isRecurring'>;

export function useHolidays(year?: number) {
  return useQuery({
    queryKey: ['holidays', year],
    queryFn: () =>
      fetcher
        .get<{ data: Holiday[] }>('/staff/v1/config/holidays')
        .then((r) => r.data ?? []),
  });
}

export function useCreateHoliday() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateHolidayInput) =>
      fetcher.post('/staff/v1/config/holidays', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] });
    },
  });
}

export function useDeleteHoliday() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      fetcher.delete(`/staff/v1/config/holidays/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] });
    },
  });
}
